exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".src-components-Manager-___controls__wrapper___3c5LQ{position:absolute;top:0;right:0;z-index:1}.src-components-Manager-___controls__create___2j8RA{margin-right:10px}\n", ""]);

// Exports
exports.locals = {
	"wrapper": "src-components-Manager-___controls__wrapper___3c5LQ",
	"create": "src-components-Manager-___controls__create___2j8RA"
};